export default "/images/logo-big.png?7c6e5503938823762f6d7ff6ecc207a1";